import { useMutation, useQueryClient } from 'react-query';
import { authFetch } from '../../CommonUtils/authFetch';
import { urlWithParams } from '../../CommonUtils/urlWithParams';
import { queryKeys } from './queryKeys';
import { ShareRevokeParams } from '../DocumentVault.meta';

const revokeThirdPartyShare = ({ clientId, path, providerType }: ShareRevokeParams) => {
  return authFetch(
    urlWithParams('/Consumer/DocumentVault/RevokeThirdPartyShare', {
      clientId,
      path,
      providerType,
    }),
    { method: 'POST' },
  );
};

export const useRevokeThirdPartyShareMutation = () => {
  const queryClient = useQueryClient();

  return useMutation(revokeThirdPartyShare, {
    onSuccess: () => {
      queryClient.invalidateQueries(queryKeys.listDocumentVaultEntities());
    },
  });
};
